import React from 'react'
import cn from 'classnames'

import styles from './index.module.css'

type CommonSpinnerProps = {
  color?: string
  className?: string
  size?: number
}

export const Spinner = ({ color = '#000000', className, size = 25 }: CommonSpinnerProps) => {
  const style: React.CSSProperties = {
    width: `${size}px`,
    height: `${size}px`,
    borderTopColor: color,
    borderRightColor: color,
    borderLeftColor: color,
  }

  return <span {...{ style }} className={cn(styles.loader, className)} />
}

Spinner.displayName = 'Spinner'
